// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1bsTa","overflowing":"ReadFullNote_overflowing__1ZEJG"};